module.exports = __webpack_public_path__ + "static/media/34.2bfd9a8c.jpg";